import apiSlice from "./apiSlice";
const normsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllNorms: builder.query({
      query: (req) => ({
        url: `norms`,
        params: req,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["AllNorms"],
    }),
    updateNorms: builder.mutation({
      query: ({ body }) => ({
        url: `norms`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["AllNorms"],
    }),
  }),
});

export const {
  useGetAllNormsQuery,
  useUpdateNormsMutation,
} = normsApiSlice;
